export const NotANumber = 'NaN';

/*
 * 文字列→数値変換
 * 数値に変換し、変換結果を確認後、返却する。
 */
export const toNumber = (value: string) => {
  const inputToNumber = Number(value);

  if (inputToNumber.toString() === NotANumber) {
    return 0;
  }
  return inputToNumber;
};
